import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AgencyRegistration } from '../../models/agency/agency-registration';
import { AgencyRegistrationRequest } from '../../models/agency/agency-registration-request';
import { PagedResult } from '../../models/PageRequestInterface';
import { BaseService } from '../shared/base.service';

@Injectable({
  providedIn: 'root'
})
export class AgencyService {

  constructor(private baseService: BaseService) { }
  AddAgencyRegistrationRequest(
    agencyRegistrationData: AgencyRegistration
  ): Observable<any> {
    return this.baseService.anonymousPost<any>(
      `Agency/AddAgencyRegistration`,
      agencyRegistrationData
    );
  }
  GetAllPendingRegistrations(
    pageIndex: number,
    pageSize: number,
    activeStatus: number
  ): Observable<PagedResult<AgencyRegistration>> {
    return this.baseService.get<PagedResult<AgencyRegistration>>(
      `Agency/GetAgencyRegistrationData?pageIndex=${pageIndex}&pageSize=${pageSize}&activeStatus=${activeStatus}`
    );
  }
  GetAllActiveInActiveRegistrations(
    pageIndex: number,
    pageSize: number,
    activeStatus: number
  ): Observable<PagedResult<AgencyRegistration>> {
    return this.baseService.get<PagedResult<AgencyRegistration>>(
      `Agency/GetAgencyData?pageIndex=${pageIndex}&pageSize=${pageSize}&activeStatus=${activeStatus}`
    );
  }


  updateAgencyRegistrationData(
    hoDto: AgencyRegistrationRequest
  ): Observable<any> {
    return this.baseService.patch<any>(
      `Agency/UpdateAgencyRegistrationData`,
      hoDto
    );

  }

  DeactiveAgency(id: number): any {
    return this.baseService.post<any>(
      `Agency/DeactivateAgency?Id=${id}`,
      {}
    );
  }
  
}
